
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  className?: string;
}

export function PageLoader({ className }: PageLoaderProps) {
  return (
    <motion.div 
      className={cn(
        "fixed inset-0 z-[9999] flex items-center justify-center bg-[#FAF9F7]",
        className
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <div className="relative flex flex-col items-center">
        <motion.img 
          src="/lovable-uploads/maison-eridia-logo.png" 
          alt="Maison Eridia" 
          className="h-16 md:h-20 mb-6"
          initial={{ opacity: 0.8, scale: 0.95 }}
          animate={{ 
            opacity: 1, 
            scale: 1,
            transition: { duration: 0.3, repeat: Infinity, repeatType: "reverse" } 
          }}
          aria-label="Chargement en cours..."
        />
        <div className="mt-4 relative">
          <motion.div 
            className="h-0.5 w-16 md:w-24 bg-muted overflow-hidden rounded-full"
          >
            <motion.div
              className="h-full bg-primary"
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{
                duration: 0.6, 
                ease: "easeInOut",
                repeat: Infinity
              }}
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
